import { Role } from './role';
import { WorkingShift } from './calendar/working-shift';

export class User {

  public password: string;
  public passwordRepeat: string;

  constructor(
    public hash?: string,
    public firstName?: string,
    public lastName?: string,
    public email?: string,
    public role?: Role,
    public reference?: number,
    public section?: number,
    public active?: boolean,
    public workingShift?: WorkingShift,
    public workingShiftName?: string
  ) { }

  get fullName() {
    return (this.lastName) ? `${ this.firstName } ${ this.lastName }` : this.firstName;
  }

  clone() {
    return new User(
      this.hash,
      this.firstName,
      this.lastName,
      this.email,
      this.role,
      this.reference,
      this.section,
      this.active,
      this.workingShift,
      this.workingShiftName
    );
  }

  get roleName() {
    return this.role ? this.role.name : '';
  }

  get filterableData() {
    return `${ this.firstName } ${ this.lastName } ${ this.email } ${ this.reference } ${ this.section } ${ this.role.name }`.toLowerCase();
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/user.ts